module.exports = __webpack_public_path__ + "img/cassa.e178e3b1.svg";